import { render } from "./ReflexTuner.vue?vue&type=template&id=0b8d7a75&scoped=true"
import script from "./ReflexTuner.vue?vue&type=script&lang=js"
export * from "./ReflexTuner.vue?vue&type=script&lang=js"

import "./ReflexTuner.vue?vue&type=style&index=0&id=0b8d7a75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8d7a75"]])

export default __exports__